/**
 * Scroll a container so that a child with a specific id becomes visible.
 * @param {HTMLElement} container - the scrollable container
 * @param {string} id - the child element id
 * @param {Object} [opts]
 * @param {'x'|'y'|'both'} [opts.axis='both'] - which axis to scroll
 * @param {'start'|'center'|'end'} [opts.align='start'] - alignment inside the container
 * @param {'auto'|'smooth'} [opts.behavior='smooth'] - scrolling behavior
 */
function scrollToIdInContainer(container, id, { axis = 'both', align = 'start', behavior = 'smooth' } = {}) {
  const target = container.querySelector(`#${CSS.escape(id)}`)
  if (!target) {
    return
  }

  const cRect = container.getBoundingClientRect()
  const tRect = target.getBoundingClientRect()

  // Distance from container’s content start to target
  const deltaLeft = tRect.left - cRect.left
  const deltaTop = tRect.top - cRect.top

  // Current absolute positions
  let left = container.scrollLeft + deltaLeft
  let top = container.scrollTop + deltaTop

  // Adjust for alignment
  if (align === 'center') {
    left -= (cRect.width - tRect.width) / 2
    top -= (cRect.height - tRect.height) / 2
  } else if (align === 'end') {
    left -= cRect.width - tRect.width
    top -= cRect.height - tRect.height
  }

  // Clamp within scrollable range
  left = Math.max(0, Math.min(left, container.scrollWidth - container.clientWidth))
  top = Math.max(0, Math.min(top, container.scrollHeight - container.clientHeight))

  const options = { behavior }
  if (axis !== 'y') {
    options.left = left
  }
  if (axis !== 'x') {
    options.top = top
  }

  container.scrollTo(options)
}

export { scrollToIdInContainer }
